import { Stack, Typography, useTheme } from "@mui/material";
import { useContext } from "react";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import CopyButton from "@/modules/common/components/ui/copy-button";

const CustomrIdField = () => {
  const { lead } = useContext(LeadPageContext);
  const theme = useTheme();

  const customerUid = lead?.data?.lead?.customer_uid;

  if (!customerUid) {
    return (
      <Typography
        sx={{
          ...theme.nawy.typography.english.variants.body.md.regular,
          color: theme.nawy.colors.semantic.text.tertiary,
        }}
      >
        Not set
      </Typography>
    );
  }

  return (
    <Stack direction="row" gap={theme.nawy.spacing.xxs} alignItems="center">
      <Typography
        sx={{
          ...theme.nawy.typography.english.variants.body.md.regular,
          color: theme.nawy.colors.semantic.text.primary,
        }}
      >
        {customerUid}
      </Typography>
      <CopyButton
        text={customerUid || ""}
        color={theme.nawy.colors.semantic.text.accent}
        size={16}
      />
    </Stack>
  );
};

export default CustomrIdField;
